export const styles = {
  wrapper: { position: 'relative' },
  hint: {
    position: 'absolute',
    bottom: 35,
    zIndex: '999',
    padding: '4px 8px',
    borderRadius: '8px',
    backgroundColor: '#fff',
    boxShadow: '0px 4px 16px 0px #2737541a',
    color: '#011533',
    width: '200%',
  },
}
